<template>
    <general-table
        :columns="columns"
        :url="route('md.table.sent')"
        :filters="filters"
        :clickableRow="clickableRow"
    >
    </general-table>
</template>

<script>
import MessageTableGroup from "./MessageTableGroup";
import MessageTableMessage from "./MessageTableMessage";
import MessageSentTableStatus from "./MessageSentTableStatus";
import MessageTableSendTime from "./MessageTableSendTime";
import MessageSentTableRecipientName from "./MessageSentTableRecipientName.vue";
import MessageSentTableDeliveryRate from "./MessageSentTableDeliveryRate.vue";
import GeneralTable from "./GeneralTable/GeneralTable.vue";
import {markRaw} from 'vue';
export default {
    components: { MessageTableGroup },
    data() {
        return {
            clickableRow: {
                route: 'message.details',
                id: 'tra_id',
            },
            columns: [
                {
                    label: "STATUS",
                    name: "status",
                    sortable: false,
                    component: markRaw(MessageSentTableStatus),
                    width: '90px',
                },
                { 
                    label: "DELIVERY RATE",
                    name: "delivery_rate",
                    sortable: false,
                    width: '110px',
                    component: markRaw(MessageSentTableDeliveryRate),
                },
                {
                    label: "RECIPIENT",
                    name: "recipient_name",
                    sortable: false,
                    width: '1fr',
                    component: markRaw(MessageSentTableRecipientName),
                },
                {
                    label: "MESSAGE",
                    name: "parsed_message",
                    sortable: false,
                    width: '1.5fr',
                    component: markRaw(MessageTableMessage),
                },
                {
                    label: "SEND DATE/TIME",
                    name: "scheduled_send_time",
                    sortable: true,
                    defaultSortDir: 'desc',
                    component: markRaw(MessageTableSendTime),
                    width: '166px'
                },
                {
                    label: "CREDITS USED",
                    name: "credits_used",
                    sortable: false,
                    width: '124px'
                },
            ],
            filters: [
                {
                    label: "Contact",
                    value: "contact",
                    type: "contact",
                    multiple: false, // because contact component already supports multiple
                },
                {
                    label: "List",
                    value: "list",
                    type: "list",
                    multiple: true,
                },
                {
                    label: "Status",
                    value: "status",
                    type: "select",
                    multiple: true,
                    options: [
                        { label: "Sent", value: "sent" },
                        { label: "Sending", value: "sending" },
                        { label: "Failed", value: "failed" },
                    ],
                },
                {
                    label: 'Recipient Type',
                    value: 'recipient_type',
                    type: 'select',
                    multiple: false,
                    options: [
                        { label: 'Contact', value: 'contact' },
                        { label: 'List', value: 'list' },
                    ]
                }
            ]
        };
    },
};
</script>
